import styled from "styled-components";
import { Accordion, Type } from "@ebscois/react-component-library";

export const StyledContentContributorInfoContainer = styled.div`
  min-width: 100%;
  margin-top: 1.25rem;
`;

export const StyledContentContributorAccordionHeader = styled(Accordion.Header)`
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  text-transform: initial;
`;

export const StyledAffiliationsType = styled(Type)`
  padding-bottom: ${({ theme }) => theme.space.sm};
`;

export const StyledConflictOfInterestType = styled(Type)`
  padding-bottom: ${({ theme }) => theme.space.sm};
  padding-top: ${({ theme }) => theme.space.md};
`;

export const StyledAcpAccordionHeader = styled(Accordion.Header)`
  line-height: 1.1rem;
`;

export const StyledAcpLogo = styled.img`
  height: 2rem;
  object-fit: contain;
`;

export const StyledAcpContainer = styled.div`
  margin-top: 1.5rem;
  display: flex;
`;

export const StyledAcpLabel = styled(Type)`
  margin-right: ${({ theme }) => theme.space.md};
`;
